<template>
  <div :class="styleClasses.card">
    <div :class="styleClasses.card_header">
      <span class="me-2">{{ formatTimestamp(reservation.datetime || reservation.created_at, 'MM/DD HH:mm') }}</span>
      <span>
        {{
          reservation.foreign_type === 21
            ? reservation.course?.label
            : reservation.route === 3
              ? '乗車'
              : reservation.user?.username || '--'
        }}
      </span>
    </div>
    <div :class="styleClasses.card_body">
      <div :class="styleClasses.card_body_content">
        <div :class="styleClasses.reservation">
          <div>
            <div
              class="mb-1"
              v-if="reservation.memo">{{ reservation.memo.memo }}</div>
            <div :class="styleClasses.locations">
              <!-- 乗車地点 -->
              <div
                :class="styleClasses.location"
                @click="mapWindowOpen('pickup')">
                <div>
                  <i class="fa-regular fa-map-location-dot"/>
                  <span class="mt-1">乗</span>
                </div>
                <div>{{ reservation.p_address?.replace('日本、', '') }}<br>{{ reservation.p_title }}</div>
              </div>
              <!-- 経由地点 -->
              <div
                v-for="(waypoint, i) in reservation.waypoints" :key="waypoint.id"
                :class="styleClasses.location"
                @click="mapWindowOpen('waypoint', i)">
                <div>
                  <i class="fa-regular fa-map-location-dot"/>
                  <span class="mt-1">経由{{ i + 1 }}</span>
                </div>
                <div>{{ waypoint.address?.replace('日本、', '') }}<br>{{ waypoint.title }}</div>
              </div>
              <!-- 降車地点 -->
              <div
                v-if="reservation.d_address || reservation.d_title"
                :class="styleClasses.location"
                class="mt-2"
                @click="mapWindowOpen('destination')">
                <div>
                  <i class="fa-regular fa-map-location-dot"/>
                  <span class="mt-1">降</span>
                </div>
                <div>{{ reservation.d_address?.replace('日本、', '') }}<br>{{ reservation.d_title }}</div>
              </div>
            </div>
          </div>
          <div :class="styleClasses.status_btns">
            <LargeBtn
              color="blue"
              @click="updateRequest(11)">了解</LargeBtn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  LargeBtn,
} from '@/components/parts';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'request',
  mixins: [cf],
  components: {
    LargeBtn,
  },
  props: {
    request: Object,
    styleClasses: Array,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user', 'helper']),
    reservation() {
      return this.request.reservation;
    },
  },
  watch: {},
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    mapWindowOpen(type, waypointIdx) {
      const rsv = this.reservation;
      if (!rsv) return;
      let position;
      switch (type) {
        case 'destination': position = { lat: rsv.d_lat, lng: rsv.d_lng }; break;
        case 'waypoint': position = { lat: rsv.waypoints[waypointIdx].lat, lng: rsv.waypoints[waypointIdx].lng }; break;
        default: position = { lat: rsv.p_lat, lng: rsv.p_lng }; break;
      }
      if (!position) return;
      this.$emit('mapWindowOpen', position);
    },

    updateRequest(flag) {
      this.$emit('updateRequest', { flag, id: this.request.id });
    },
  },
};
</script>
